import React from 'react';
import { Paper } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { Message } from 'models';
import withBreadcrumbs from 'hocs/withBreadcrumbs';
import AddNewMessageForm from '../form';
import useStyles from './style';

interface StateProps {
  message?: Message;
}

const AddNewMessageDialog: React.FC<{}> = () => {
  const classes = useStyles();
  const location = useLocation();
  const state = location.state as StateProps;
  const message = state ? state.message : undefined;

  return (
    <Paper className={classes.container}>
      <AddNewMessageForm message={message} />
    </Paper>
  );
};

export default withBreadcrumbs(AddNewMessageDialog);
